import { Component, Input } from '@angular/core';
import { FormatCardNumberPipe } from '@shared/pipes/format-card-number-pipe';
import { NgxBarcode6Module } from 'ngx-barcode6';

@Component({
  selector: 'app-plusmore-card',
  imports: [NgxBarcode6Module, FormatCardNumberPipe],
  templateUrl: './plusmore-card.html',
  styleUrl: './plusmore-card.scss',
  standalone: true,
})
export class PlusmoreCard {
  @Input() cardNumber!: string;
  @Input() name: string = 'Member';
}
